
import { Component, Vue } from "vue-property-decorator";
import { StoreProductService } from "src/services";
import { Toast, Dialog } from "vant";
import { tools } from "src/utils";
import dayjs from "dayjs";
import globalConfig from "src/config/index";
import OrgList from './org-list.vue'


Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate" // for vue-router 2.2+
]);

@Component({
    components:{
        OrgList
    }
})
export default class PackageDetail extends Vue
{

    /**
     * 权益id
     * @private
     * @returns string
     */
    private get isRightsIdToBuy(): string
    {
        return this.$route.query && (this.$route.query.isRightsIdToBuy as string) || "";
    }

    /**
     * 展开与折叠
     * @private
     * @returns boolean
     */
    private activeNames:any = ['1'];
    

    /**
     * 默认隐藏
     * @private
     * @returns boolean
     */
     private isHidden:boolean = false;

      /**
     * 排期数据
     * @private
     * @returns any
     */
    private weekList: any = ["周日","周一", "周二", "周三","周四", "周五","周六"];


    /**
     * 套餐信息
     * @private
     * @returns any
     */
    private packageInfo: any = {
        bannerImages:[],
        baseItemCount:null,
        baseItemTypes:[],
        hospitalCount:null,
        isPut:null,
        name:"",
        provinces:[],  // 省份
        rightsProductId:null,
        supplierProductId:null,
        tags:[],
        infoImages:[],
        introduce:""
    };


     /**
     * 展开全部
     * @private
     * @returns void
     */
    public expandAll() {
       this.isHidden = !this.isHidden
    }

    /**
     * 显示套餐对比
     * @protected
     * @returns boolean
     */
    public showComparePopup: boolean = false;

    private schedulingData = []


    /**
     * 套餐id
     * @private
     * @returns string
     */
    private get packageId(): string
    {
        return this.$route.query && (this.$route.query.packageId as string) || "";
    }


    /**
     * 组件创建
     * @private
     * @returns void
     */
    private created(): void
    {
        if(this.packageId) {
            this.getPackageDetail(this.packageId);
        }

    }


    /**
     * 关闭弹窗
     * @protected
     * @returns void
     */
     protected closeComparePopup() {
        this.showComparePopup = false
     }


    /**
     * 显示日历空间日期
     * @private
     * @returns void
     */
    private handlerCalendar(schedulesObj: any): void
    {
        let dateList = [];
        // 获取下个月最后一天
        // let nextMonthDay = dayjs().add(1, "month").endOf('month');
        // 获取间隔天数
        // let intervalDay = dayjs(nextMonthDay).diff(dayjs(),'day');

        for(let i = 0; i<60; i++)
        {
            let current = dayjs().add(i, "day").format("YYYY-MM-DD");

            let num = 0
            let surplusType = 1;
            let currenObj = schedulesObj[current];
            if(currenObj)
            {
                num = currenObj.personCount;
                surplusType = currenObj.surplusType;
            }
            let obj =
            {
                date: current,
                num: num,
                surplusType: surplusType,
                txt: dayjs(current).format("MM.DD"),
                week: this.weekList[dayjs(current).day()]
            };
            dateList.push(obj)
        }
        this.schedulingData = dateList;
    }

    /**
     * 获取套餐详情
     * @private
     * @returns void
     */
    private async getPackageDetail(id: any): Promise<void>
    {
        try
        {
            let {content: result} =  await StoreProductService.instance.getRightsProductDetail(id);
            for (const key in this.packageInfo) {
                this.packageInfo[key] = result.data[key]
            }

        }
        catch(err)
        {
            Toast(err);
        }
    }

 

}
